<div
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <div
    attr.pdlPageComponentId="{{ pdlPageComponentId }}"
    attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
    [ngClass]="{ 'connect-theme': showConnect }"
  >
    <div (window:resize)="onResize($event)">
      <header class="container-fluid" role="navigation" #header>
        <div class="top-bar" id="top-nav-bar">
          <nav class="content">
            <!-- <p *ngIf="isWebChannel" class="small left-links" role="menu"> -->
            <p class="small left-links" role="menu">
              <ng-container
                *ngFor="
                  let link of globalNavLinksData;
                  let first = first;
                  let last = last;
                  let idx = index
                "
              >
                <a
                  role="menuitem"
                  class="me-2"
                  [ngClass]="{ bold: first }"
                  attr.aria-label="{{ link?.targetLabel }}{{ globalContent?.globalMessages?.site }}"
                  (click)="externalUrlClick(link)"
                  tabindex="0"
                >
                  {{ link.targetLabel }}
                </a>
                <!-- <span class="spacer" aria-hidden="true" *ngIf="!last"></span> -->
              </ng-container>
            </p>
            <!-- <p class="small left-links float-end" *ngIf="isWebChannel"> -->
            <p class="small left-links float-end">
              <a mporgnav href="{{ navigateTo }}" (click)="switchLanguage('es')">
                {{ toggleLanguage }}
              </a>
            </p>
            <!-- <p class="small left-links float-end" *ngIf="isRapChannel">
          <span>{{interactionId}}</span>
        </p> -->
          </nav>
        </div>
        <nav class="content" (tmoClickOutside)="openSearchBox()">
          <ng-container *ngFor="let leftLink of navigationData?.leftLinks">
            <a
              *ngIf="(isLoggedIn && leftLink?.showAuth) || (!isLoggedIn && leftLink?.showUnAuth)"
              attr.aria-label="{{ globalContent?.globalMessages?.goHome }}"
              role="tab"
              tmoAnchorDetect
              [link]="leftLink?.url"
              [isNewTab]="leftLink?.newTab"
              [seoHref]="true"
              (click)="navigateToRoute(leftLink.url, leftLink.newTab)"
              accesskey="1"
              [ngClass]="{
                disabled: hideGlobalNav,
                'logo-change': leftLink?.showConnect,
                logo: !leftLink?.showConnect,
              }"
            >
              <img
                id="tmobile-image"
                src="{{ leftLink?.labelImage1 }}"
                [alt]="leftLink?.showConnect ? 'Connect by T-Mobile Logo' : 'T-Mobile Logo'"
              />
            </a>
          </ng-container>
          <div
            class="content-wrapper"
            [hidden]="hideGlobalNav"
            [ngClass]="{ 'toggle-menu': isMenuClosed }"
          >
            <ul class="links-menu">
              <ng-container
                *ngFor="let dropListLink of filteredNavigationData?.dropListLinks; let idx = index"
              >
                <li class="d-lg-none" *ngIf="dropListLink.label === 'My T-Mobile'">
                  <!-- <a *ngIf="!isRapChannel" class="menu-item" href="javascript:void(0)" [ngClass]="{'open': (isMytmoSubMenus && (isWebChannel || isLoggedIn)) || (-2 === openIndex)}"
                 [class.disabled]="!isWebChannel && !isLoggedIn" (click)="onMytmobileMainMenuItemClick(dropListLink)" attr.aria-label="{{globalContent?.globalMessages?.myTmobile}}"
                 tabindex="{{(isDesktop && (isWebChannel || isLoggedIn)) ? '0' : '-1'}}" role="menu">
                <span class="title-fonts">{{dropListLink?.label | uppercase}}</span>
                <i class="fa fa-angle-down carret" aria-hidden="true" (click)="navigateToRoute(dropListLink.url, dropListLink.newTab)"
                   *ngIf="isWebChannel || isLoggedIn"></i>
              </a> -->
                  <a
                    class="menu-item"
                    href="javascript:void(0)"
                    [ngClass]="{ open: (isMytmoSubMenus && isLoggedIn) || -2 === openIndex }"
                    (click)="onMytmobileMainMenuItemClick(dropListLink)"
                    attr.aria-label="{{ globalContent?.globalMessages?.myTmobile }}"
                    tabindex="{{ isDesktop && isLoggedIn ? '0' : '-1' }}"
                    role="menu"
                  >
                    <span class="title-fonts">{{ dropListLink?.label }}</span>
                    <i
                      class="fa fa-angle-down carret"
                      aria-hidden="true"
                      (click)="navigateToRoute(dropListLink.url, dropListLink.newTab)"
                      *ngIf="isLoggedIn"
                    ></i>
                  </a>
                  <!-- <div *ngIf="!isRapChannel" class="submenu-container"> -->
                  <div class="submenu-container">
                    <!-- <ul class="small submenu" role="menu" [ngClass]="{'open': isMytmoSubMenus , 'collapse': !isMytmoSubMenus}" *ngIf="(isWebChannel || isLoggedIn)"> -->
                    <ul
                      class="small submenu"
                      role="menu"
                      [ngClass]="{ open: isMytmoSubMenus, collapse: !isMytmoSubMenus }"
                      *ngIf="isLoggedIn"
                    >
                      <li
                        class="small submenu"
                        *ngFor="let subMenulink of dropListLink?.secondaryLinks"
                      >
                        <a
                          id="top-sub-menu"
                          class="submenu-item"
                          tmoPdl
                          id="subMenulink"
                          tmoAnchorDetect
                          [link]="subMenulink?.url"
                          [isNewTab]="subMenulink?.newTab"
                          [seoHref]="true"
                          (click)="onSubMenuItemClick(subMenulink)"
                          (click)="navigateToRoute(subMenulink.url, subMenulink.newTab)"
                          [class.disabled]="subMenulink?.url === '/refill-account' && isTouristPlan"
                          >{{ subMenulink?.label }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </li>
              </ng-container>
              <li *ngFor="let menuLink of filteredNavigationData?.menuLinks; let idx = index">
                <!-- <a class="menu-item" role="tab" href="javascript:void(0)" [ngClass]="{'open': this.isShowSubMenus[idx]}" *ngIf="menuLink?.secondaryLinks?.length; else noMenu"
              (click)="shouldNavigateToPlanServices && menuLink?.label === 'Plans' ? clickOnCart() : onMainMenuItemClick(idx)" [class.disabled]="((menuLink?.url === '/refill-account') && isTouristPlan) || (menuLink.label === 'Plans' && !isAddLinePermission)">
             <span class="title-fonts" id="menuItem{{idx}}">{{menuLink.label | uppercase}}</span>
             <i [ngClass]="{ 'fa fa-angle-down carret' : !(shouldNavigateToPlanServices && menuLink?.label === 'Plans') }" aria-hidden="true"></i>
           </a> -->
                <a
                  class="menu-item"
                  role="tab"
                  href="javascript:void(0)"
                  [ngClass]="{ open: this.isShowSubMenus[idx] }"
                  *ngIf="menuLink?.secondaryLinks?.length; else noMenu"
                  (click)="menuLink?.secondaryLinks?.length ? onMainMenuItemClick(idx) : ''"
                  (mouseenter)="isDesktop ? onMainMenuItemClick(idx) : ''"
                  (mouseleave)="isDesktop ? onMainMenuItemClick(idx, true) : ''"
                  [class.disabled]="
                    (menuLink?.url === '/refill-account' && isTouristPlan) ||
                    (menuLink.label === 'Plans' && !isAddLinePermission)
                  "
                >
                  <span class="title-fonts" id="menuItem{{ idx }}">{{ menuLink.label }}</span>
                  <i class="fa fa-angle-down carret" aria-hidden="true"></i>
                </a>
                <ng-template #noMenu="">
                  <a
                    (mouseover)="isDesktop ? hideVerticalMenu() : ''"
                    id="no-menu"
                    role="tab"
                    class="menu-item"
                    [ngClass]="{ open: this.isShowSubMenus[idx] }"
                    *ngIf="menuLink?.label === navBarConstants.COVERAGE; else noMap"
                    tmoAnchorDetect
                    [link]="menuLink?.url"
                    [isNewTab]="menuLink?.newTab"
                    [seoHref]="true"
                    (click)="
                      onMainMenuItemClick(idx); navigateToRoute(menuLink.url, menuLink.newTab)
                    "
                    [class.disabled]="menuLink?.url === '/refill-account' && isTouristPlan"
                  >
                    <span class="title-fonts" id="no-menu{{ idx }}">{{ menuLink.label }}</span>
                  </a>
                  <ng-template #noMap="">
                    <a
                      (mouseover)="isDesktop ? hideVerticalMenu() : ''"
                      id="no-map"
                      role="tab"
                      class="menu-item"
                      [ngClass]="{ open: this.isShowSubMenus[idx] }"
                      tmoAnchorDetect
                      [link]="menuLink?.url"
                      [isNewTab]="menuLink?.newTab"
                      [seoHref]="true"
                      (click)="
                        onMainMenuItemClick(idx); navigateToRoute(menuLink.url, menuLink.newTab)
                      "
                      [class.disabled]="menuLink?.url === '/refill-account' && isTouristPlan"
                    >
                      <span class="title-fonts" id="no-map{{ idx }}">{{ menuLink.label }}</span>
                    </a>
                  </ng-template>
                </ng-template>

                <div
                  class="submenu-container"
                  (mouseleave)="isDesktop ? onMainMenuItemClick(idx, true) : ''"
                  (mouseenter)="isDesktop ? onMainMenuItemClick(idx) : ''"
                  [ngClass]="{
                    open: this.isShowSubMenus[idx],
                    collapse: !this.isShowSubMenus[idx],
                  }"
                >
                  <ul class="small submenu">
                    <li
                      class="submenu-item"
                      [ngClass]="{ full: menuLink.label === firstMenuLinkLabel }"
                      *ngFor="let subMenulink of menuLink?.secondaryLinks"
                    >
                      <a
                        [class.disabled]="
                          !isPermissionAvailable ||
                          (!isOrderDevicePermission &&
                            (subMenulink?.label === navBarConstants.PHONES ||
                              subMenulink?.label === navBarConstants.TABLETS_AND_MORE)) ||
                          (!isAccessoryPermission &&
                            subMenulink?.label === navBarConstants.ACCESSORIES)
                        "
                        id="sub-menu"
                        role="tab"
                        *ngIf="
                          menuLink?.label === navBarConstants.PLANS ||
                            (menuLink?.label === navBarConstants.SHOP &&
                              subMenulink?.label === navBarConstants.ACCESSORIES) ||
                            subMenulink?.label === navBarConstants.PHONES ||
                            subMenulink?.label === navBarConstants.TABLETS_AND_MORE;
                          else noBrowse
                        "
                        tmoAnchorDetect
                        [link]="subMenulink?.url"
                        [isNewTab]="subMenulink?.newTab"
                        [seoHref]="true"
                        (click)="
                          onSubMenuItemClick(subMenulink, idx);
                          navigateToRoute(subMenulink.url, subMenulink.newTab)
                        "
                        >{{ subMenulink?.label }}</a
                      >
                      <ng-template #noBrowse="">
                        <a
                          *ngIf="subMenulink?.label !== navBarConstants.CLIENT_ID"
                          id="no-browse"
                          tmoAnchorDetect
                          [link]="subMenulink?.url"
                          [isNewTab]="subMenulink?.newTab"
                          [seoHref]="true"
                          (click)="
                            onSubMenuItemClick(subMenulink);
                            navigateToRoute(subMenulink.url, subMenulink.newTab)
                          "
                          [class.disabled]="!isPermissionAvailable"
                          >{{ subMenulink?.label }}</a
                        >
                      </ng-template>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div class="right-menu" role="menu">
            <a
              class="store"
              title="Store"
              role="menuitem"
              attr.aria-label="{{ globalContent?.globalMessages?.storeLocator }}"
              tmoAnchorDetect
              [link]="'https://www.t-mobile.com/store-locator.html'"
              [isNewTab]="true"
              [seoHref]="true"
              (click)="navigateToRoute('https://www.t-mobile.com/store-locator.html', true)"
              id="cta-store-locator"
            >
              <i class="img-icon store-outlined" aria-hidden="true"></i>
            </a>
            <a
              class="cart"
              [class.disabled]="
                hideGlobalNav ||
                !isPermissionAvailable ||
                !isAccessoryPermission ||
                !isOrderDevicePermission
              "
              href="javascript:void(0)"
              title="Cart"
              role="menuitem"
              attr.aria-label="{{ globalContent?.globalMessages?.shoppingCart }}"
              (click)="clickOnCart()"
              id="cta-shopping-cart"
            >
              <i class="img-icon shopping-cart-outlined" aria-hidden="true">
                <!-- <span *ngIf="!isRapChannel" class="small data-count">{{cartItemCount}}</span> -->
                <span *ngIf="cartItemCount > 0" class="small data-count">{{ cartItemCount }}</span>
              </i>
            </a>
            <ng-container>
              <!-- <a *ngIf="!isRapChannel && !isP10MCustomer" class="search" [class.disabled]="!isPermissionAvailable || !isOrderDevicePermission || !isAccessoryPermission" [hidden]="hideGlobalNav" href="javascript:void(0)" title="Search" role="menuitem" (click)="toggleSearchBox()" accesskey="4" id="cta-default-192"></a> -->
              <a
                *ngIf="!isP10MCustomer"
                class="search"
                [class.disabled]="
                  !isPermissionAvailable || !isOrderDevicePermission || !isAccessoryPermission
                "
                [hidden]="hideGlobalNav"
                href="javascript:void(0)"
                title="Search"
                role="menuitem"
                (click)="toggleSearchBox()"
                accesskey="4"
                id="cta-default-192"
              >
                <i class="img-icon search-outlined" aria-hidden="true"></i>
              </a>
              <div class="searchbox-position" role="searchbox">
                <div class="header-search" [ngClass]="{ 'box-hidden': !showSearchBar }">
                  <tmo-search
                    *ngIf="showSearchBar"
                    (closeSearchBox)="closeSearchBox()"
                    [aemContent]="globalContent?.globalMessages"
                  ></tmo-search>
                </div>
              </div>
            </ng-container>

            <a
              class="nav"
              href="javascript:void(0)"
              title="Menu"
              aria-label="Main Navigation"
              role="menuitem"
              (click)="toggleVerticalMenu()"
            >
              <i class="fa fa-navicon" aria-hidden="true"></i>
            </a>
            <!-- <ul *ngIf="!isRapChannel" class="links-menu d-none d-lg-block" role="menu" [hidden]="hideGlobalNav"> -->
            <ul class="links-menu d-none inline-flex" role="menu" [hidden]="hideGlobalNav">
              <li
                role="menuitem"
                *ngFor="let dropListLink of filteredNavigationData?.dropListLinks; let idx = index"
              >
                <!-- <a class="my-button" *ngIf="dropListLink.label==='My T-Mobile'" [ngClass]="{'open': isMytmoSubMenus && (isWebChannel || isLoggedIn)|| (-2 === openIndex)}"
                  [class.disabled]="!isWebChannel && !isLoggedIn" (click)="onMytmobileMainMenuItemClick(dropListLink); showSearchBar = false" attr.aria-label="{{globalContent?.globalMessages?.myTmobile}}"
                  tabindex="{{(isDesktop && (isWebChannel || isLoggedIn)) ? '0' : '-1'}}">{{dropListLink?.label | uppercase}}
                  <i class="fa fa-angle-down carret" aria-hidden="true" tmoAnchorDetect [link]="dropListLink?.url" [isNewTab]="dropListLink?.newTab" [seoHref]="true" (click)="navigateToRoute(dropListLink.url, dropListLink.newTab)"
                    *ngIf="(isWebChannel && isLoggedIn) || isLoggedIn"></i>
                </a> -->
                <a
                  class="my-button"
                  *ngIf="dropListLink.label === 'My T-Mobile'"
                  [ngClass]="{ open: (isMytmoSubMenus && isLoggedIn) || -2 === openIndex }"
                  (click)="onMytmobileMainMenuItemClick(dropListLink); showSearchBar = false"
                  attr.aria-label="{{ globalContent?.globalMessages?.myTmobile }}"
                  tabindex="{{ isDesktop && isLoggedIn ? '0' : '-1' }}"
                  >{{ dropListLink?.label | uppercase }}
                  <i
                    class="fa fa-angle-down carret"
                    aria-hidden="true"
                    tmoAnchorDetect
                    [link]="dropListLink?.url"
                    [isNewTab]="dropListLink?.newTab"
                    [seoHref]="true"
                    (click)="navigateToRoute(dropListLink.url, dropListLink.newTab)"
                    *ngIf="isLoggedIn"
                  ></i>
                </a>
                <div
                  class="submenu-container"
                  [ngClass]="{ open: isMytmoSubMenus, collapse: !isMytmoSubMenus }"
                >
                  <span class="mytmo-submenu-container">
                    <span class="mytmo-submenu right">
                      <!-- <ul class="small submenu" role="menu" [ngClass]="{'open': isMytmoSubMenus , 'collapse': !isMytmoSubMenus}" *ngIf="(isWebChannel || isLoggedIn)">
                        <li class="submenu-item" role="menuitem" *ngFor="let subMenulink of dropListLink?.secondaryLinks">
                          <a href="javascript:void(0)" (click)="onSubMenuItemClick(subMenulink); navigateToRoute(subMenulink.url, subMenulink.newTab)"  tmoPdl  id="subMenulink" [class.disabled]="(subMenulink?.url === '/refill-account') && isTouristPlan">{{subMenulink?.label}}</a>
                        </li>
                      </ul> -->
                      <ul class="small submenu" role="menu" *ngIf="isLoggedIn">
                        <li
                          class="submenu-item"
                          role="menuitem"
                          *ngFor="let subMenulink of dropListLink?.secondaryLinks"
                        >
                          <a
                            href="javascript:void(0)"
                            (click)="
                              onSubMenuItemClick(subMenulink);
                              navigateToRoute(subMenulink.url, subMenulink.newTab)
                            "
                            tmoPdl
                            id="subMenulink"
                            [class.disabled]="
                              subMenulink?.url === '/refill-account' && isTouristPlan
                            "
                            >{{ subMenulink?.label }}</a
                          >
                        </li>
                      </ul>
                    </span>
                  </span>
                </div>
              </li>
            </ul>
            <!-- <ul *ngIf="isRapChannel" class="links-menu d-none d-lg-block" role="menu">
              <li role="menuitem" *ngFor="let dropListLink of filteredNavigationData?.dropListLinks let idx = index;">
                  <a class="my-button" *ngIf="dropListLink.label==='Logout'" href="javascript:void(0)" (click)="userLogout(); showSearchBar = false" attr.aria-label="Log Out"
                  tabindex="{{(isDesktop && (isWebChannel || isLoggedIn)) ? '0' : '-1'}}">{{dropListLink?.label | uppercase}}
                  </a>
              </li>
          </ul> -->
          </div>
        </nav>
      </header>
      <tmo-static-modal
        pdlPageComponentId="navbar-static-modal"
        id="navigate-to-ext"
        [modal]="modalData"
        (onSelect)="navigateToExternalUrl($event)"
      ></tmo-static-modal>
    </div>
    <tmo-dynamic-modal
      pdlPageComponentId="navbar-dynamic-modal"
      id="unsaved-selections"
      [modal]="modal"
    >
      <div class="container">
        <p-header>
          <div class="modal-logo-close">
            <i class="tmo-icon-logo" aria-label="T-Mobile Logo"></i>
            <a
              class="close-x pull-right"
              href="javascript:void(0)"
              title="Close"
              id="cta-default-195"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>
          </div>
          <h3>{{ globalContent?.globalMessages?.unsavedSelections }}</h3>
        </p-header>
        <div class="col-12 n-padding">
          <p class="small">
            {{ globalContent?.globalMessages?.incompleteLinesMessage }}
          </p>
        </div>
        <p-footer>
          <div class="row">
            <div class="col-12 buttons-container button-spacing">
              <div class="button-box">
                <button id="back" class="btn btn-secondary" role="button" (click)="dissmissModal()">
                  {{ globalContent?.globalMessages?.goBackToSelector }}
                </button>
              </div>
              <div class="button-box">
                <button
                  id="continue"
                  class="btn btn-primary"
                  role="button"
                  (click)="navigateToCart()"
                >
                  {{ globalContent?.globalMessages?.continueWithoutSaving }}
                </button>
              </div>
            </div>
          </div>
        </p-footer>
      </div>
    </tmo-dynamic-modal>
    <tmo-spinner role="alert" [setDelay]="navigationData"></tmo-spinner>
    <!-- Zip Code Modal -->
    <tmo-entry-modal [modal]="entryModalData"></tmo-entry-modal>
  </div>
</div>
